import { createColumnHelper } from '@tanstack/react-table';

export interface IUserPayHoursTable {
  //TODO this type could be part of the state
  id: number;
  type: 'weekly' | 'daily';
  defaultHours: number;
  defaultOvertimeFactor: number;
  overrideHours: number;
  overrideOvertimeFactor: number;
}
export const columnHelper = createColumnHelper<IUserPayHoursTable>();

export const ROW_ID_PREFIX = 'user-pay-hours-row';
